import { Component, Mixins } from 'vue-property-decorator';
import PaymentRequirementsIncomingLoader from '../Unprocessed/PaymentRequirementsIncomingLoader';
import PaymentRequirementsIncomingCheckerDialog from '@/feature/PaymentRequirements/components/Incoming/PaymentRequirementsIncomingCheckerDialog.vue';

@Component({
	components: {
		PaymentRequirementsIncomingCheckerDialog
	}
})
export default class PaymentRequirementsIncomingChecker extends Mixins(
	PaymentRequirementsIncomingLoader
) {

	paymentRequirementsCheckerDialog: boolean = false

	async checkHasPaymentRequirementsIncoming(): Promise<boolean | null> {
		const paymentRequirements = await this.loadUnprocessedPaymentRequirements();

		return paymentRequirements
			? !!paymentRequirements.length
			: paymentRequirements as null;
	}

	async checkHasPaymentRequirementsIncomingAndShowDialog(): Promise<boolean> {
		const hasPaymentRequirements = await this
			.checkHasPaymentRequirementsIncoming();

		if (hasPaymentRequirements === null) return true;

		this.paymentRequirementsCheckerDialog = hasPaymentRequirements;

		return hasPaymentRequirements;
	}

}